import { Link } from 'gatsby';
import styled from 'styled-components';

export default styled(Link)`
  &:active {
    opacity: .7;
  }
`
